/*
 * instant.page v5.2.0 — DISABLED (Frantic, 2026-08-01)
 *
 * WHY
 * instant.page prefetched a whole HTML document whenever the visitor hovered a
 * link, and assets/component-product-form.js does the same for variant URLs.
 * Those documents land in the browser's prefetch cache keyed by URL only.
 * Shopify storefront HTML does not vary by the buyer's country, so after a
 * customer switched market (US -> DE/CA/AU) the browser could replay a page
 * that had been rendered for the previous market: old prices, old currency,
 * the old country in the footer selector, and the US-only duties badge.
 *
 * With 9 markets and 8 currencies that is a recurring correctness problem, and
 * the workaround (snippets/market-sync.liquid) had to reload such pages, which
 * customers see as a flicker mid-purchase. Removing the prefetching removes
 * the cause, so those reloads should stop happening at all.
 *
 * WHAT THIS FILE DOES NOW
 * 1. Nothing on its own - no hover prefetching.
 * 2. It strips document-level <link rel="prefetch"> hints that other scripts
 *    add (component-product-form.js #prefetchPage), because that file is 44 KB
 *    and not safe to hand-edit. Asset preloads (rel="preload") and
 *    rel="dns-prefetch" are deliberately left alone - only whole-page
 *    prefetching is neutralised.
 *
 * TRADE-OFF
 * Clicking a link is roughly 100-200 ms less "instant". Prices, currency and
 * country are always the ones the customer actually selected.
 *
 * HOW TO REVERT
 * Copy assets/instantpage.js from any older theme, e.g. "MAIN CURRENT"
 * (theme 201266299221), where the original v5.2.0 is untouched. Then also
 * delete this file's observer.
 */

(function () {
  function isDocumentPrefetch(link) {
    if (!link || link.tagName !== 'LINK') { return false; }
    if (String(link.getAttribute('rel')).trim().toLowerCase() !== 'prefetch') { return false; }
    var as = String(link.getAttribute('as') || '').trim().toLowerCase();
    // only whole pages: instant.page uses as="document", component-product-form sets no as
    return as === '' || as === 'document';
  }

  function strip(root) {
    var links = (root || document).querySelectorAll ? (root || document).querySelectorAll('link[rel="prefetch"]') : [];
    for (var i = 0; i < links.length; i++) {
      if (isDocumentPrefetch(links[i]) && links[i].parentNode) {
        links[i].parentNode.removeChild(links[i]);
      }
    }
  }

  strip(document);

  try {
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var added = records[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          if (isDocumentPrefetch(added[j]) && added[j].parentNode) {
            added[j].parentNode.removeChild(added[j]);
          }
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) {}
})();
